"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Anchor = _interopRequireDefault(require("./Anchor"));

var _AnchorLink = _interopRequireDefault(require("./AnchorLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Anchor["default"].Link = _AnchorLink["default"];
var _default = _Anchor["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/anchor/index.js
// module id = 657
// module chunks = 0